<template>
  <div id="nav" ref="navRef">
    <!-- <router-link to="/">Home</router-link> | -->
    <!-- {{ router.currentRoute.fullPath }}
    v-if="router.currentRoute.fullPath != '/article'" -->
    <div class="nav_left">
      <div
        class="iconfont"
        @click="backToIndex"
        :style="{ color: colorFilter(router.currentRoute.value.fullPath)[0] }"
      >
        &#xe601;
      </div>
      <!-- <span>{{ router.currentRoute.value.fullPath }}</span> -->
    </div>
    <div class="nav_right">
      <div
        v-for="(item, index) in navArr"
        :key="index"
        class="nav_rightItem"
        :ref="setRef1"
      >
        <span class="iconfont" v-if="index != navArr.length">&#xe722;</span>
        <router-link
          :style="{ color: colorFilter(router.currentRoute.value.fullPath)[0] }"
          :to="item.to"
          @mouseover.native="handleMouseover(item, index)"
          @mouseout.native="handleMouseout(item, index)"
          @click="handleClick(item, index)"
        >
          {{ $i18n.locale == "ch" ? item.title : item.titleEn }}</router-link
        >
      </div>
    </div>
    <div class="languageBtn" @click="switchLocale">
      {{ $i18n.locale == "ch" ? "EN" : "中文" }}
    </div>
  </div>
  <!-- <div class="notice" v-if="isVisible">
    <img
      class="closeIcon"
      src="../src/assets/close.png"
      alt=""
      @click="closeNotice"
    />
    <h3 class="title">主题：关于您成像服务原始数据存储期限的重要通知</h3>
    <p class="p1">尊敬的客户：</p>
    <p class="p2">
      感谢贵公司长期选用千乘镜像（北京）科技有限公司的成像服务。
      我们特此通知，贵公司的成像服务数据已存储超过一年。根据我司的数据留存政策，为优化存储资源并确保您的原始数据安全，我们建议您对重要数据进行备份。
      请贵公司于本通知发出之日起一周内（即2025年10月28日前）通过邮箱与我司联系。
    </p>
    <h4 class="mailAddress">TDCS@qianchengjx.com</h4>
    <p class="p3">
      <span>重要提示：</span>
      若在上述期限届满后，我们仍未收到贵公司的数据拷贝请求或任何形式的联系，该部分数据将被视为自动放弃。届时，千乘镜像（北京）科技有限公司将有权对相关数据进行清理，且不再承担保管责任。
    </p>
    <p class="p4">
      数据安全至关重要，我们建议您积极响应此次通知，以免造成不可挽回的数据丢失。如您有任何疑问，请邮件与我们联系。TDCS@qianchengjx.com
    </p>
    <p class="p5">再次感谢您的理解与配合！</p>
    <p class="cizhi">此致</p>
    <p class="jingli">敬礼！</p>
    <div class="outerPBOX">
      <div class="pbox">
        <p class="p6">千乘镜像（北京）科技有限公司</p>
        <p class="p7">生物技术部</p>
        <p class="p8">2025年10月22日</p>
      </div>
    </div>
  </div> -->
  <!-- style="
      position: fixed;
      width: 60px;
      height: 60px;
      border-radius: 30px;
      right: 50px;
      bottom: 50px;
      z-index: 999999;" -->
  <div @click="showMessgeHandle" class="imgBox">
    <img
      src="@/assets/common/kefu.png"
      style="width: inherit; border-radius: inherit; cursor: pointer"
    />
  </div>
  <router-view />
  <Footer
    :backgroundColor="colorFilter(router.currentRoute.value.fullPath)[2]"
    :pagePosition="colorFilter(router.currentRoute.value.fullPath)[3]"
    @handle-click="handleClick"
  ></Footer>
  <chatBox></chatBox>
</template>

<script>
import { ref, getCurrentInstance, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import i18n from "@/language/index";
import Footer from "./components/Footer.vue";
import chatBox from "./components/chatBox";
export default {
  components: { Footer, chatBox },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const proxy = getCurrentInstance();
    // arrow color:active颜色
    const navRef = ref(null);
    const isVisible = ref(true);
    const navArr = ref([
      {
        to: "/",
        title: "首页",
        titleEn: "Home",
        color: "#8c7bd9",
        show: false,
      },
      {
        to: "/about",
        title: "关于我们",
        titleEn: "About us",
        color: "#e92ea3",
        show: false,
      },
      {
        to: "",
        title: "数据库",
        titleEn: "TD DATA",
        color: "#4f24ee",
        show: false,
      },
      {
        to: "/technology",
        title: "技术服务",
        titleEn: "Technical service",
        color: "#3399ff",
        show: false,
      },
      {
        to: "/product",
        title: "产品",
        titleEn: "Product",
        color: "#add800",
        show: false,
      },
      {
        to: "/article",
        title: "热门文章",
        titleEn: "Hot article",
        color: "#16c494",
        show: false,
      },
      {
        to: "/contact",
        title: "联系我们",
        titleEn: "Contact",
        color: "#e92ea3",
        show: false,
      },
      // {
      //   to: "",
      //   title: "English",
      //   titleEn: "中文",
      //   color: "#ffb607",
      //   show: false,
      // },
    ]);
    onMounted(() => {
      // console.log(" app onMounted", router.currentRoute.value);
      // document.getElementById('myDialog').showModal();
    });

    const refArr = ref([]);
    const setRef1 = function (e) {
      refArr.value.push(e);
    };
    const backToIndex = function () {
      router.push("/");
    };
    // 移入
    const handleMouseover = function (item, index) {
      // console.log("handleMouseover",href_href);
      if (index < navArr.value.length) {
        // arrow
        refArr.value[index].children[0].style.opacity = 1;
        refArr.value[index].children[0].style.color = item.color;
        refArr.value[index].children[1].style.color = item.color;
        refArr.value[index].style.transform = "translate(10px,0px)";
        refArr.value[index].style.transition = "all 0.4s";
      }
    };
    // 移出
    const handleMouseout = function (item, index) {
      let href_href = router.currentRoute.value.fullPath;
      // console.log(
      //   "handleMouseout",
      //   item.to,
      //   href_href,
      //   navRef.value.style.backgroundColor
      // );

      if (index < navArr.value.length) {
        // arrow
        refArr.value[index].children[0].style.opacity = 0;
        refArr.value[index].children[0].style.color = "";
        refArr.value[index].children[1].style.color =
          item.to == href_href
            ? colorFilter(item.to)[1]
            : colorFilter(href_href)[0];
        if (navRef.value.style.backgroundColor == "rgb(234, 232, 228)") {
          refArr.value[index].children[1].style.color = "#2D2D2D";
        }
        refArr.value[index].style.transform = "translate(0px,0px)";
        refArr.value[index].style.transition = "all 0.4s";
      }
    };

    // 点击
    const handleClick = function (item, index) {
      let href_href = router.currentRoute.value.fullPath;
      // console.log(
      //   "handleClick",
      //   refArr.value[index].children[1],
      //   item.to,
      //   colorFilter(item.to)[1]
      // );
      // arrow

      if (index == navArr.length - 1) {
        refArr.value[index].children[0].style.opacity = 1;
      } else {
        refArr.value[index].children[0].style.opacity = 0;
        refArr.value[index].style.transform = "translate(0px,0px)";
        refArr.value[index].style.transition = "all 0.5s";
        setTimeout(() => {
          refArr.value[index].children[1].style.color = colorFilter(item.to)[1];
        }, 10);
      }

      if (item.to) {
        router.push(item.to);
      }
      if (item.title == "数据库") {
        window.open("https://www.qctddata.com/", "_blank");
      }
      if (index == navArr.length - 1) {
        let current = i18n.global.locale;
        // navArr.value[navArr.value.length - 1].title =
        //   current == "ch" ? "English" : "中文";
        i18n.global.locale = current == "ch" ? "en" : "ch";
      }
    };
    // item通用
    const colorFilter = function (url) {
      // let href_href = router.currentRoute.value.fullPath;
      // 通用-被选中路由-footer背景色
      switch (url) {
        case "/":
          return ["#eae8e4", "blue", "#5729ff", ""];
          break;
        case "/about":
          return ["#2D2D2D", "#ADD800", "#448d79", "absolute"];
          break;
        case "/article":
          return ["#2d2d2d", "blue", "#99bf00", ""];
          break;
        // case "/searchArticle":
        //   return ["#2d2d2d", "blue", "#99bf00"];
        //   break;
        case "/technology":
          return ["#CBF6FF", "#3399FF", "#0061c2", ""];
          break;
        case "/product":
          return ["#EDFFAB", "#ADD800", "#950341", ""];
          break;
        case "/contact":
          return ["#2d2d2d", "blue", "#db6800", ""];
          break;
        default:
          // return ["#eae8e4", "blue", "#5729ff"];
          return ["#2d2d2d", "blue", "#99bf00", ""];
          break;
      }
    };
    // document.onscroll = function () {
    //   console.log("app scroll");
    // };
    const switchLocale = function () {
      // console.log(i18n);
      i18n.global.locale = i18n.global.locale == "ch" ? "en" : "ch";
    };

    const showMessgeHandle = function () {
      document.getElementById("myDialog").showModal();
    };

    const closeNotice = function () {
      // console.log("closeImg", isVisible);
      isVisible.value = !isVisible.value;
    };

    return {
      backToIndex,
      colorFilter,
      router,
      navArr,
      setRef1,
      handleMouseover,
      handleMouseout,
      handleClick,
      navRef,
      switchLocale,
      showMessgeHandle,
      closeNotice,
      isVisible,
    };
  },
};
</script>
<style lang="scss">
@import "../src/assets/style/common.scss";
#app {
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
  margin: 0px;
  padding: 0px;
  background-color: #eae8e4;
}
// .notice {
//   width: 57%;
//   position: absolute;
//   top: 50%;
//   left: 50%;
//   transform: translate(-50%, -50%);
//   z-index: 998;
//   font-size: 19px;
//   padding: 20px;
//   background-color: rgba(255, 255, 255, 0.5);
//   backdrop-filter: blur(27px);
//   border-radius: 10px;
//   .closeIcon {
//     position: absolute;
//     z-index: 999;
//     width: 40px;
//     right: 0px;
//     top: 0px;
//     cursor: pointer;
//   }
//   .title {
//     font-size: 22px;
//     text-align: center;
//   }
//   p {
//     margin-top: 10px;
//   }
//   .mailAddress {
//     text-indent: 27px;
//     margin-top: 10px;
//   }
//   .p2,
//   .p5 {
//     text-indent: 27px;
//   }
//   .p3 {
//     text-indent: 27px;
//     span {
//       font-weight: bold;
//     }
//   }
//   .cizhi {
//     text-indent: 27px;
//     font-weight: bold;
//   }
//   .jingli {
//     font-weight: bold;
//   }
//   .outerPBOX {
//     display: flex;
//     justify-content: flex-end;
//     .pbox {
//       display: inline-block;
//       text-align: end;
//       .p6 {
//         text-align: end;
//       }
//       .p7,
//       .p8 {
//         text-align: center;
//         margin: 0px;
//         margin-top: 10px;
//       }
//     }
//   }
// }
.imgBox {
  position: fixed;
  width: 80px;
  // height: 60px;
  border-radius: 30px;
  right: 50px;
  bottom: 50px;
  z-index: 999999;
}
#nav {
  position: fixed;
  // top: 2vh;
  left: 0;
  width: 100%;
  height: 4vh;
  @include rowBetweenCenter;
  // border-bottom: 1px solid #2d2d2d2d;
  z-index: 1000;
  padding-bottom: 1.5vh;
  padding-top: 1.5vh;
  .nav_left {
    position: absolute;
    z-index: 2000;
    .iconfont {
      // font-size: 44px;
      font-size: 2.3vw;
      color: #2d2d2d;
      margin-left: 3.05vw;
      margin-left: 2.5vw;
      cursor: pointer;
    }
  }

  .nav_right {
    position: absolute;
    display: flex;
    color: #eae8e4;
    right: 3.05vw;
    z-index: 2000;
    .nav_rightItem {
      padding: 0vw 0.9vw;
      cursor: pointer;
      a {
        font-size: 1.2vw;
        color: #2d2d2d;
        text-decoration: none;
      }
      .iconfont {
        opacity: 0;
        font-size: 0.96vw;
        transition: all 0.6s;
      }
    }
  }
  .languageBtn {
    position: absolute;
    color: #8c7bd9;
    font-size: 1.2vw;
    font-weight: bold;
    right: 1vw;
    cursor: pointer;
  }
  .chat_Btn {
    position: fixed;
    right: 80px;
    bottom: 100px;
    width: 80px;
    height: auto;
    z-index: 999999;
    background-color: #fff;
    border-radius: 40px;
  }
}
</style>
